module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/assessment_achievements/5@2x_5214c7e828e7860ebce1af437e3c3c22.png";